import { useCallback, useState } from 'react';
import Modal from '@/components/UI/Modal/Modal';
import Button from '@/components/UI/Button/Button';
import assignmentsStyles from '@features/assignments/styles/assignment.module.scss';
import { AssignmentFormSelect } from './AssignmentFormSelect';

interface Props {
  handleClose: () => void;
  open: boolean;
  taskTitle: string;
}

export const ReprocessTaskModal = ({ open, handleClose, taskTitle }: Props) => {
  const [whoIsReturned, setWhoIsReturned] = useState<{ name: string; email: string }>({ name: '', email: '' });
  const [typeReturn] = useState<number>(0);
  const [textAreaStyle, setTextAreaStyle] = useState<string>('assigncalentask__m-textarea');
  const [comment, setComment] = useState<string>('');

  const handleTextArea = useCallback((ev: React.ChangeEvent<HTMLTextAreaElement>) => {
    setComment(ev.target.value);
    setTextAreaStyle('assigncalentask__m-textarea');
  }, []);

  const postComment = useCallback(async () => {
    try {
      // Logic commented out, preserving for now
    } catch (error) {
      console.error('Post comment failed:', error);
    }
  }, []);

  const sendComment = useCallback(() => {
    if (comment.length < 4) {
      setTextAreaStyle('assigncalentask__m-textarea-error');
    } else if (whoIsReturned.email !== '') {
      postComment();
    }
  }, [comment, whoIsReturned.email, postComment]);

  const modalFooter = (
    <>
      <Button variant="secondary" onClick={handleClose}>Cancelar</Button>
      <Button variant="primary" onClick={sendComment}>Aceptar</Button>
    </>
  );

  return (
    <Modal
      isOpen={open}
      onClose={handleClose}
      title="Reprocesar tarea"
      footer={modalFooter}
    >
      <div className={assignmentsStyles['assigncalentask__paper']}>
        {typeReturn === 2 && (
          <div className={assignmentsStyles['assigncalentask__m-select']}>
            <div className={assignmentsStyles['assigncalentask__m-body']}>
              Por favor señale quien le asigno la tarea
            </div>
            <AssignmentFormSelect
              title=""
              item={whoIsReturned}
              setItem={setWhoIsReturned}
            />
          </div>
        )}
        <div className={assignmentsStyles['assigncalentask__m-body']}>
          Por favor, añade un comentario que justifique el reproceso de la tarea: <strong>"{taskTitle}"</strong>.
        </div>
        <textarea
          className={assignmentsStyles[textAreaStyle]}
          rows={6}
          onChange={handleTextArea}
          placeholder="Escribe tu comentario aquí..."
        />
      </div>
    </Modal>
  );
};
